let payload = null;
try {
	payload = JSON.parse(document.getElementById("esc-payload").textContent);
} catch {
	console.warn("Payload not present");
}

export const data = payload && payload.data ? payload.data : {};
export const session = payload && payload.session ? payload.session : {};
export const serverTime =
	payload && payload.serverTime ? payload.serverTime : "";
